<template>
  <div
    class="loading-spinner absolute w-full h-full top-0 left-0 z-10"
    :class="{ delay: delay }"
  >
    <div class="overlay absolute w-full h-full bg-whiteOverride opacity-70" />
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200px"
      height="200px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      class="spinner stroke-current text-primary"
    >
      <circle
        cx="50"
        cy="50"
        r="32"
        stroke-width="3"
        stroke-dasharray="50 50"
        fill="none"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'TWLoadingSpinner',
  props: {
    delay: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.loading-spinner,
.overlay {
  border-radius: inherit;
}

.loading-spinner.delay {
  opacity: 0;
  animation: 0.3s linear 0.5s forwards fadeIn;
}
.spinner {
  @apply absolute
    top-2/4
    left-2/4;

  width: 150px;
  height: 150px;
  transform: translate(-50%, -50%);
  animation: 1.3s linear infinite spin;
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
